import React, { useState } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import '../../shared/styles/base.css'; // Importar estilos compartidos

// Importar componentes V2 (completamente independientes en TypeScript)
import Header from './components/Header';
import Footer from './components/Footer';
import MapComponent from './components/map/MapComponent';
import Sidebar from './components/ui/Sidebar';
import NotificationCenter from '../../shared/components/ui/NotificationCenter';
import IfcInputPanel from './components/ui/IfcInputPanel';
import CadasterInputPanel from './components/ui/CadasterInputPanel';
import LoadingModal from '../../shared/components/ui/LoadingModal';
import ModalManager from '../../shared/components/ui/ModalManager';
import UpdateBanner from '../../shared/components/ui/UpdateBanner';
import { MapService } from './services/map/mapService';
import { useUIStore } from './stores';
import DrawingPanel from './components/ui/DrawingPanel';
import ConfigurationPanel from './components/ui/ConfigurationPanel';
import CalculationsPanel from './components/ui/CalculationsPanel';
import ElementsTablePanel from './components/ui/ElementsTablePanel';
import ExportPanel from './components/ui/ExportPanel';

const App: React.FC = () => {
  const [mapService, setMapService] = useState<MapService | null>(null);
  const { panels, closePanel } = useUIStore();

  const handleMapServiceReady = (service: MapService) => {
    setMapService(service);
  };

  return (
    <Authenticator>
      {({ signOut, user }) => (
        <div className="v2-app">
          {/* Banner de actualización - se muestra automáticamente si hay nueva versión */}
          <UpdateBanner checkInterval={5 * 60 * 1000} showDismiss={true} />
          
          <Header user={user} signOut={signOut} />
          
          <main className="v2-main-content">
            {/* Sidebar con herramientas */}
            <Sidebar />
            
            {/* Contenedor del mapa que ocupa todo el espacio disponible */}
            <div className="v2-map-container">
              <MapComponent 
                className="v2-map-component" 
                onMapServiceReady={handleMapServiceReady}
              />
            </div>
          </main>

          {/* Panel de IFC - sin overlay para no bloquear interacciones */}
          <IfcInputPanel 
            isOpen={panels.ifcInput} 
            onClose={() => closePanel('ifcInput')}
            mapService={mapService}
          />

          {/* Panel de Catastro - sin overlay para no bloquear interacciones */}
          <CadasterInputPanel 
            isOpen={panels.cadasterInput}
            onClose={() => closePanel('cadasterInput')}
            mapService={mapService}
          />

          {/* Panel de Herramientas de Dibujo - sin overlay para no bloquear interacciones */}
          <DrawingPanel 
            isOpen={panels.drawing}
            onClose={() => closePanel('drawing')}
            mapService={mapService}
          />

          {/* Panel de Configuración - sin overlay para no bloquear interacciones */}
          <ConfigurationPanel 
            isOpen={panels.configuration}
            onClose={() => closePanel('configuration')}
          />

                    {/* Panel de Cálculos - sin overlay para no bloquear interacciones */}
          <CalculationsPanel
            isOpen={panels.calculations}
            onClose={() => closePanel('calculations')}
            mapService={mapService}
          />

          {/* Panel de Tabla de Elementos - desplegable desde abajo */}
          <ElementsTablePanel mapService={mapService} />

          {/* Panel de Exportación - sin overlay para no bloquear interacciones */}
          <ExportPanel 
            isOpen={panels.export}
            onClose={() => closePanel('export')}
            mapService={mapService}
          />

          {/* Centro de notificaciones */}
          <NotificationCenter />
          <LoadingModal />
          <ModalManager />

          <Footer />
        </div>
      )}
    </Authenticator>
  );
};

export default App;